<div class="tw-w-full tw-p-5 tw-relative tw-font-body tw-pt-12">
  <span class="tw-w-20 tw-h-[3px] tw-rounded-lg tw-absolute tw-top-1.5 tw-left-1/2 -tw-translate-x-1/2 tw-bg-[#D9D9D9]"></span>
  @if (fromSelfCheckupBanner) {
    <p class="tw-text-600 tw-font-bold tw-w-[85%] tw-mb-3" i18n="@@answerForProgress">Answer a few questions so your doctor can check your progress</p>
  }
  @if (!fromSelfCheckupBanner) {
    <p class="tw-text-700 tw-font-bold tw-w-[85%] tw-mb-3" i18n="@@addMoreInsights">Add more insights for a detailed report</p>
  }
  <div class="tw-w-full tw-mb-6">
    @if (fromSelfCheckupBanner) {
      <p class="tw-text-300" i18n="@@doctorWillUseAnswers">Doctor will use this photo and your answers to create a check-up report.</p>
    }
    @if (!fromSelfCheckupBanner) {
      <p class="tw-text-300" i18n="@@doctorCanGuideYouBetter">Your doctor can guide you better if you answer a few more questions. Want to continue?</p>
    }
  </div>
  <div class="tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3">
    @if (fromSelfCheckupBanner) {
      <span class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-3 tw-px-8 tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold tw-relative tw-overflow-hidden" i18n="@@answerForCheckup" (click)="navigateToChat()">Answer Questions for check-up</span>
    }
    @if (!fromSelfCheckupBanner) {
      <span class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-3 tw-px-8 tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold tw-relative tw-overflow-hidden" i18n="@@keepAnswering" (click)="closePopup()">Keep Answering</span>
    }
    <span class="tw-w-full tw-border tw-border-teal-600 tw-text-teal-600 tw-py-3 tw-px-8 tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold tw-relative tw-overflow-hidden" i18n="@@skipForNow" (click)="skipChat()">Skip for Now</span>
  </div>
  <div
    class="tw-absolute tw-flex tw-justify-center tw-items-center tw-z-[100] tw-top-4 tw-right-4 close-sheet"
    style="width: 38px; height: 38px"
    >
    <div class="tw-text-gray-500 tw-text-500 tw-font-bold" (click)="closePopup()">&#10005;</div>
  </div>
</div>
